import { StreamMap } from '@m43/core';
import { MessagePayload } from '@m43/sockets-mark43';

/* Returns eventId when a nudge signals that `eventId`'s disposition may have changed, otherwise
 * []. DISP = a disposition changed, EC = an event clearing changed; either can flip a disposition's
 * enabled/editable state, so both are matched. Entries carry `e` = agency event id. Shared by the
 * active-disposition query and the kebab-menu context-menu query so the two stay in sync. */
export function matchesDispositionNudge(
    message: MessagePayload<StreamMap, 'nudge'>,
    eventId: number | undefined
): number[] {
    if (!eventId) {
        return [];
    }

    for (const key of ['DISP', 'EC']) {
        const entries = message.payload.map[key];
        if (!entries) {
            continue;
        }
        if (entries.some((entry) => entry.e === eventId)) {
            return [eventId];
        }
    }

    return [];
}
